G.Helpers = G.Helpers || {};

G.Helpers.pushOutOfCoinsPopUp = function (forced, eventConfig, hideFreeGift = true) {
  if (G.IAP) {
    G.sb('pushWindow').dispatch(
      [
        'coinShop',
        { forced, hideFreeGift },
      ],
      forced,
      G.WindowMgr.LayerNames.Base,
    );
    OMT.platformTracking.logEvent(OMT.platformTracking.Events.OpenShop);
    if (eventConfig) {
      OMT.platformTracking.logEvent(eventConfig.event, eventConfig.payload);
    }
    return true;
  }
  if (game.incentivised()) {
    G.sb('pushWindow').dispatch(['dailyWheel', {
      worldState: game.state.current === 'World',
      asMoreMoney: true,
    }]);
    return true;
  }
  return false;
};
